import type { HandleExceptionParams } from './types'
import toastNotification from 'pug/toastNotification'
import { CENSUS } from 'sites/routes'
import {
  INVALID_PROFILE_URL_KEY,
  INVALID_PROFILE_EXCEPTION,
  INVALID_SIGNATURE_DOCUMENT_EXCEPTION,
  INVALID_SIGNATURE_DOCUMENT_URL_KEY,
  AppHandledException
} from 'core/constants/exceptions'

const defaultParams = {
  text: 'An unexpected error has ocurred. Please try refreshing the page or click the button below to start over.',
  actionText: 'Go back to the beginning',
  actionLink: CENSUS
}

const createNotification = (params: HandleExceptionParams, notificationParam: string) => {
  return {
    text: params.message || defaultParams.text,
    action: {
      text: params.actionText || defaultParams.actionText,
      link: `${params.actionLink || defaultParams.actionLink}${notificationParam}`
    }
  }
}

const errorSimpleMap: Record<string, string> = {
  [INVALID_PROFILE_EXCEPTION]: INVALID_PROFILE_URL_KEY,
  [INVALID_SIGNATURE_DOCUMENT_EXCEPTION]: INVALID_SIGNATURE_DOCUMENT_URL_KEY
}

const handleException =
  (params: HandleExceptionParams = {}) =>
  (e: unknown) => {
    let notificationParam = ''

    if ((e as AppHandledException)._tag === 'AppHandledException') {
      const { key } = e as AppHandledException
      notificationParam = `?notification=${key}`
    } else if (typeof e === 'string' && errorSimpleMap[e]) {
      notificationParam = `?notification=${errorSimpleMap[e]}`
    }

    const notification = createNotification(params, notificationParam)
    toastNotification(notification, 15000)

    console.error(e)
  }

export default handleException
